<interacta-user-notification [notification]="notification()" />
<div class="mt-8 ml-56 flex space-x-4 empty:hidden">
    @if (attachment(); as attachment) {
        <button
            class="rounded-3xl"
            type="button"
            (click)="clickOnAttachment($event, notification())"
        >
            <interacta-attachment-chip
                class="min-w-0"
                [attachment]="attachment"
                [bgColor]="'surface-B'"
                [slim]="true"
            />
        </button>
    }
    @if (otherAttachments(); as otherAttachments) {
        <button
            class="shrink-0 rounded-full bg-surface-B px-8 py-4 typo-xs-bold"
            type="button"
            (click)="clickOnAttachment($event, notification())"
        >
            + {{ otherAttachments }}
        </button>
    }
</div>
